import { render, staticRenderFns } from "./CustomizeExpiredBefore.vue?vue&type=template&id=43108956&"
import script from "./CustomizeExpiredBefore.vue?vue&type=script&lang=js&"
export * from "./CustomizeExpiredBefore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports